"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function useOnClickOutside(ref, handler, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var callback = React.useCallback(function (event) { return handler(event); }, deps !== null && deps !== void 0 ? deps : []);
    React.useEffect(function () {
        var _a;
        var el = (_a = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _a !== void 0 ? _a : ref;
        if (!el)
            return undefined;
        var throttle = false;
        var listener = function (event) {
            if (!el || !el.contains || el.contains(event.target) || throttle) {
                return;
            }
            throttle = true;
            setTimeout(function () { return (throttle = false); }, 500);
            callback(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        document.addEventListener('click', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('click', listener);
        };
    }, [ref, callback]);
}
exports.default = useOnClickOutside;
